import { TThunkAction } from '../../types/redux';
import {
  fetchSendFormAnalytics,
  TSendFormAnalyticsRequest,
} from '../../repositories/lead-realtor-form/v1/send-form-analytics';

export const sendFormAnalytics = (parameters: TSendFormAnalyticsRequest): TThunkAction<Promise<void>> => {
  return async (dispatch, getState, context) => {
    const { httpApi, logger } = context;

    try {
      await fetchSendFormAnalytics({
        httpApi,
        parameters,
      });
    } catch (error) {
      logger.error(error, {
        domain: 'sendFormAnalytics.ts',
      });
    }
  };
};
